"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VehicleImageService = void 0;
class VehicleImageService {
    constructor(vehicleImageClient, loggingFacade) {
        this.vehicleImageClient = vehicleImageClient;
        this.loggingFacade = loggingFacade;
    }
    async getVehicleImages(vehicle) {
        try {
            const response = await this.vehicleImageClient.getImages(vehicle);
            if (!response.images) {
                throw new Error('No images in response from vehicle image service');
            }
            if (response.service === VehicleImageService.vilmaDefaultProvider) {
                return [];
            }
            return response.images;
        }
        catch (e) {
            this.loggingFacade.error('Could not fetch vehicle images', e);
            return [];
        }
    }
}
exports.VehicleImageService = VehicleImageService;
VehicleImageService.vilmaDefaultProvider = 'DEFAULT';
//# sourceMappingURL=VehicleImageService.js.map